import locales from '@/config/locales.config.js';

export default (prismicLocale) => {
    return locales
        .find(locale => locale.prismic === prismicLocale)
        .domain;
};